<template>
    <card title="Solicitudes por Confirmar" icon="list-alt">
        <span v-if="isCourier || isAdmin || isMainComercial">
            <div class="table-responsive" v-if="trackings.length > 0">
                <span v-for="tracking in trackings" :key="tracking.id">
                    <div class="card mb-4 shadow">
                        <div class="card-body">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead class="thead-dark">
                                        <tr>
                                            <th>Servicio de Transporte</th>
                                            <th>N° de Seguimiento</th>
                                            <th>N° de Guía</th>
                                            <th>Fecha de envío</th>
                                            <th>Fecha estimada de llegada</th>
                                            <th style="width: 240px;">Seguimiento</th>
                                            <th style="width: 100px;">Confirmar</th>
                                        </tr>
                                        <tr>
                                            <td class="bg-info">
                                                <span class="mt-1 badge badge-info px-3 m-text">{{
                                                    tracking.tracking.courier }}</span>
                                            </td>
                                            <td class="bg-success">
                                                <span class="mt-1 badge badge-success px-3 m-text">{{
                                                    tracking.tracking.trackingNumber }}</span>
                                            </td>
                                            <td class="bg-success">
                                                <span class="mt-1 badge badge-success px-3 m-text">{{
                                                    tracking.tracking.transportDispatchGuide}}</span>
                                            </td>
                                            <td>{{ tracking.tracking.shippingDateCourierString }}</td>
                                            <td>{{ tracking.tracking.estimatedArrivedDateAtString }}</td>
                                            <td class="bg-warning">
                                                <a title="Ver Seguimiento" class="btn btn-warning a-td"
                                                    :href="tracking.tracking.trackingUrl" target="_blank">
                                                    <b>Ver Seguimiento</b>
                                                    <i class="fas fa-truck ml-2"></i>
                                                </a>
                                            </td>
                                            <td class="text-center bg-success">
                                                <button type="button" class="btn btn-success a-td"
                                                    @click="showModalArrival(tracking.tracking)"
                                                    title="Confirmar Arribo">
                                                    <i class="fas fa-check-circle"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </thead>
                                </table>
                                <a @click="changeIconCollapse(tracking.tracking.courier.replace(/ /g, '') + tracking.tracking.trackingNumber.replace(/ /g, ''))"
                                    style="width: 100%; background-color: #f7f7f7;" class="btn " data-toggle="collapse"
                                    :href="'#collapse' + tracking.tracking.courier.replace(/ /g, '') + tracking.tracking.trackingNumber.replace(/ /g, '')"
                                    role="button" aria-expanded="false"
                                    :aria-controls="'collapse' + tracking.tracking.courier.replace(/ /g, '') + tracking.tracking.trackingNumber.replace(/ /g, '')">
                                    Fcom Asociados
                                    <i class="fas fa-angle-down ml-4"
                                        :id="'icon' + tracking.tracking.courier.replace(/ /g, '') + tracking.tracking.trackingNumber.replace(/ /g, '')"></i>
                                </a>
                                <div class="card collapse multi-collapse"
                                    :id="'collapse' + tracking.tracking.courier.replace(/ /g, '') + tracking.tracking.trackingNumber.replace(/ /g, '')">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <table class="table table-sm">
                                                    <tr>
                                                        <th>N° FCOM</th>
                                                        <th>Fecha de solicitud</th>
                                                        <th>Fecha requerida de Despacho</th>
                                                        <th>Despacho Progresivo</th>
                                                        <th>Items</th>
                                                    </tr>
                                                    <tr v-for="r in tracking.requestSampleTracking" :key="r.id">
                                                        <td>{{ r.requestCommercialSample.id }}</td>
                                                        <td>{{ r.requestCommercialSample.createdAtString }}</td>
                                                        <td>{{ r.requestCommercialSample.requiredDispatchDateString }}
                                                        </td>
                                                        <td v-if="r.requestCommercialSample.progressDispatch == true">
                                                            <span
                                                                class="badge badge-pill badge-secondary badgeBoolean">Si</span>
                                                        </td>
                                                        <td v-if="r.requestCommercialSample.progressDispatch == false">
                                                            <span
                                                                class="badge badge-pill badge-dark badgeBoolean">No</span>
                                                        </td>
                                                        <td>
                                                            <button type="button" class="btn btn-info"
                                                                @click="showModalDetail(r.requestCommercialSampleDetail, r.requestCommercialSample.id)"
                                                                title="Ver Items de Fcom">
                                                                <i class="fa fa-eye"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </span>
            </div>
            <alert class="mt-4" v-else message="Aún no se registran Despachos por confirmar" />
            <modal id="itemsFcom" :title="modalTitle" @modalClose="index" :lg="true">
                <details-request-courier :details="details" :components="components"></details-request-courier>
            </modal>
            <modal id="ArrivalDate" :title="modalTitle" @modalClose="index">
                <arrival-date @pressOk="save"></arrival-date>
            </modal>
        </span>
        <paginator class="mt-4" :links="links"></paginator>
    </card>
</template>

<script>
import { Get, Put } from '../../../helper/axios.js'
import Card from "@/components/Card.vue";
import $ from "jquery";
import { getUrlQuery } from "../../../helper/queryHelper";
export default {
    components: {
        Card
    },
    data() {
        return {
            apiUrl: this.$store.getters.apiUrl,
            Get,
            Put,
            isAdmin: this.$store.getters.isAdmin,
            isMainComercial: this.$store.getters.isMainComercial,
            isCourier: this.$store.getters.isCourier,
            confirmTracking: {
                trackingNumber: "",
                courier: "",
                realArrivalDateAt: "",
            },
            trackings: [],
            requestDataList: [],
            modalTitle: "",
            details: [],
            detailsList: [],
            components: [],
            requests: [],
            links: {},
            getUrlQuery
        }
    },
    watch: {
        urlQuery: function () {
            this.index()
        }
    },
    created() {
        this.index();
    },
    methods: {
        index() {
            this.getTrackings();
        },
        getTrackings() {
            this.detailsList = [];
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl + "v1/trackingscourier?" + this.urlQuery, (res) => {
                this.trackings = res.data.data;
                this.links = res.data.links;
                this.$store.commit("setLoading", false);
            });
        },
        showModalDetail(lines, request_id) {
            this.details = [];
            this.details = lines;
            this.modalTitle =
                "Fcom N° " + request_id + " - Detalles de muestras despachadas";
            $("#itemsFcom").modal("show");
        },
        showModalArrival(tracking) {
            this.confirmTracking.trackingNumber = tracking.trackingNumber;
            this.confirmTracking.courier = tracking.courier;
            this.confirmTracking.transportDispatchGuide = '';
            if (tracking.transportDispatchGuide)
                this.confirmTracking.transportDispatchGuide = tracking.transportDispatchGuide
            this.modalTitle = "Fecha de Arribo";
            $("#ArrivalDate").modal("show");
        },
        GetRequestSampleList(trackingId) {
            var data = {}
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl + "v1/trackingscourier/GetRequestByTracking/" + trackingId, (res) => {
                this.$store.commit("setLoading", false);
                data = res.data
            });
            return data;
        },
        save(arrival_date) {
            this.confirmTracking.realArrivalDateAt = arrival_date;
            this.$swal({
                title: "¿Desea confirmar arribo?",
                html:
                    "<span><b>Courier: </b>" +
                    this.confirmTracking.courier +
                    " </span></br><span><b>N° Seguimiento: </b>" +
                    this.confirmTracking.trackingNumber +
                    " </span></br><span><b>N° Guía: </b>" +
                    this.confirmTracking.transportDispatchGuide +
                    " </span></br><span><b>Fecha de arribo:  </b>" +
                    arrival_date +
                    "</span></br>",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
            }).then((result) => {
                if (result.value) {
                    $("#ArrivalDate").modal("hide");
                    this.$store.commit("setLoading", true);
                    this.Put(
                        this.apiUrl + "v1/trackingscourier/",
                        this.confirmTracking,
                        () => {
                            this.confirmTracking.trackingNumber = "";
                            this.confirmTracking.courier = "";
                            this.confirmTracking.realArrivalDateAt = "";
                            this.$store.commit("setLoading", false);
                            window.toastr.success("N° Guía Confirmado correctamente");
                            this.$router.go(this.$router.currentRoute);

                        }
                    );
                }
            });
        },
        changeIconCollapse(item) {
            if ($('#icon' + item).hasClass('fa-angle-down')) {
                $('#icon' + item).toggleClass("fa-angle-up")
            }
            else if ($('#icon' + item).hasClass('fa-angle-up')) {
                $('#icon' + item).toggleClass("fa-angle-down")
            }
        },
    },
    computed: {
        urlQuery() {
            return this.getUrlQuery()
        }
    }
}
</script>